(function() {
    'use strict';

    angular
        .module('app.core')
        .run(appRun);

    /* @ngInject */
    function appRun(routerHelper) {
        var otherwise = '/Error/NotFound';
        routerHelper.configureStates(getStates(), otherwise);
    }
    /* @ngInject */
    function getStates() {
        return [
            {
                state: 'error',
                config: {
                    url: '/Error',
                    abstract:true,
                    template: '<ui-view/>'
                }
            },
            {
                state: 'error.404',
                config: {
                    url: '/NotFound',
                    templateUrl: 'app/core/404.html',
                    title: 'Not Found',
                    sideBarVisible: false
                }
            },
            {
                state: 'error.403',
                config: {
                    url: '/Forbidden',
                    templateUrl: 'app/core/forbidden/403.html',
                    title: 'Forbidden',
                    sideBarVisible: false
                }
            },
            {
                state: 'error.200',
                config: {
                    url: '/Health',
                    templateUrl: 'app/core/200.html',
                    title: 'Health',
                    sideBarVisible: false
                }
            }
        ];
    }
})();
